import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskOncallScheduleRoute: InvariantJiraRoute = {
	name: 'servicedesk-oncall-schedule',
	path: '/jira/servicedesk/projects/:projectKey/on-call-schedule',
	exact: true,
};
